import {Injectable} from '@angular/core';
import {AbstractDataServiceDtoAdapter} from '../../../../../core/service/v2/dataservice/adapter/abstractDataServiceDto.adapter';
import {ReportDefinitionModel} from '../../../api/entity/reportDefinition.model';
import {ReportDefinitionConverter} from '../../../api/entity/converter/reportDefinition.converter';
import {ReportDefinitionDataService} from './reportDefinitionData.service';

@Injectable()
export class ReportDefinitionDataServiceAdapter extends AbstractDataServiceDtoAdapter<ReportDefinitionModel, ReportDefinitionConverter> {
    constructor(dataService: ReportDefinitionDataService, converter: ReportDefinitionConverter) {
        super(dataService, converter);
    }

    newStoredEntityInstance(): ReportDefinitionModel {
        return new ReportDefinitionModel();
    }
}
